import * as React from 'react';
import { observer } from 'mobx-react';
import { dateSRLocale } from '../../../../utils/date';
import { useTranslation } from 'react-i18next';
import { Switch } from '../../../../components/UI/switch/Switch';
import { NewsletterListElementModelType } from '../../../../internal';
import styles from './NewsletterListElement.module.scss';

export const NewsletterListElement = observer(
  (props: {
    model: NewsletterListElementModelType;
    openNewsletterDetailsPage: (id: number) => void;
    currentPage: any;
    index: number;
    activePaginationPage: number;
    lastPaginationPage: number;
    naturalIndex: number;
    currentPageElementCount: number;
  }): JSX.Element => {
    const { model, currentPage } = props;
    const { t } = useTranslation();

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      currentPage.toggleActiveNewsletter(model.id, e.target.checked);
    };

    return (
      <div
        className={styles.Container}
        style={{
          borderRightColor:
            model.status === 1
              ? 'var(--activestatus)'
              : 'var(--inactivestatus)',
        }}
      >
        <div className={styles.MainContentContainer}>
          <div className={styles.LeftContainer}>
            <div
              className={styles.Title}
              onClick={() => props.openNewsletterDetailsPage(model.id)}
            >
              {model.name || 'Name'}
            </div>
            <p style={{ margin: '15px 0 0 0', padding: 0, fontSize: '13px' }}>
              By: {model.createdBy}
            </p>
          </div>
        </div>
        <div className={styles.RightContainer}>
          <div className={styles.RightText}>
            <Switch checked={model.status === 1} onChange={onChange} />
          </div>
          <div className={styles.RightText}>
            Status:
            <span
              style={{
                marginLeft: '5px',
                color:
                  model.status === 1
                    ? 'var(--activestatus)'
                    : 'var(--inactivestatus)',
              }}
            >
              {t(model.status === 1 ? 'banners:active' : 'banners:inactive')}
            </span>
          </div>
          <div className={styles.RightText}>
            <span>
              Period:{' '}
              {`${dateSRLocale(
                new Date(model.dateStart as string)
              )} - ${dateSRLocale(new Date(model.dateEnd as string))}`}
            </span>
          </div>
        </div>
      </div>
    );
  }
);
